import React, { Component } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';

function Experience() {


 

  return (
    <section style={{ padding: '10vh 20vh 10vh 20vh', textAlign: 'left' }}>
    <div className="shadow p-3 mb-3 bg-white rounded card"  >
      <div className="card-body" style={{backgroundColor :"#210090" ,color:"white"}}>
        <div className="card-title h5" >
        Joodek
        </div>
        <div className="mb-2  card-subtitle h6">
        Stagiaire
        </div>
        <div className="mb-2  card-subtitle h6">
        PHP LARAVEL
        </div>
        <p className="card-text">
        Juillet 2022 - Aout 2022
        </p>
      </div>
    </div>
   
  </section>
);
  
}

export default Experience;
